import React from "react";
import { Link } from "react-router-dom";
import { ALLERGEN_ORDER, ALLERGEN_DOT, itemAllergens } from "@/lib/nutrition";

export default function AllergenDots({ item, testid, className = "", link = true }) {
  if (!item) return null;
  const list = ALLERGEN_ORDER.filter((a) => itemAllergens(item).includes(a));
  if (!list.length) return null;
  const cls = `flex flex-wrap items-center gap-x-2.5 gap-y-0.5 text-[10px] font-bold text-biga-ink/60 ${className}`;
  const dots = list.map((a) => (
    <span key={a} className="inline-flex items-center gap-1"><span className={`w-2 h-2 rounded-full ${ALLERGEN_DOT[a]}`} />{a}</span>
  ));
  if (!link) return <div className={cls} data-testid={testid} aria-label={`Contains ${list.join(", ")}`}>{dots}</div>;
  return <Link to="/nutrition" title="See nutrition & allergens" data-testid={testid} className={`${cls} hover:text-biga-ink`}>{dots}</Link>;
}
